module.exports = __webpack_public_path__ + "img/top-function-report-detail.fe4b1472.jpg";